import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 16v-8h2a2 2 0 1 1 0 4h-2","key":"svg-0"}],["path",{"d":"M12 8v8","key":"svg-1"}],["path",{"d":"M4 8h4l-4 8h4","key":"svg-2"}]]

/**
 * IconZip
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItemlwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNiAxNnYtOGgyYTIgMiAwIDEgMSAwIDRoLTIiIC8+CiAgPHBhdGggZD0iTTEyIDh2OCIgLz4KICA8cGF0aCBkPSJNNCA4aDRsLTQgOGg0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zip
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZip = createReactComponent('outline', 'zip', 'Zip', __iconNode);

export default IconZip;